import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  ref: "endOfList",
  id: "endOfList"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_ctx.paginatedResult)
    ? (_openBlock(), _createBlock(_component_Multiselect, {
        key: 0,
        id: "multiselect",
        ref: "multiselect",
        modelValue: _ctx.inputVal,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputVal) = $event)),
        searchable: true,
        options: 
      async function () {
        return _ctx.paginatedResult.items;
      }
    ,
        placeholder: _ctx.placeholder,
        label: "name",
        valueProp: "id",
        closeOnSelect: true,
        canClear: false,
        disabled: _ctx.disabled,
        onOpen: _ctx.onOpen,
        onClose: _ctx.onClose
      }, {
        afterlist: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _withDirectives(_createElementVNode("span", { class: "loading apollo" }, _toDisplayString(_ctx.loadingMessage), 513), [
              [_vShow, _ctx.loading]
            ])
          ], 512)
        ]),
        caret: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("span", { class: "multiselect-custom-caret" }, " > ", -1)
        ]))]),
        _: 1
      }, 8, ["modelValue", "options", "placeholder", "disabled", "onOpen", "onClose"]))
    : _createCommentVNode("", true)
}